import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaSearch } from 'react-icons/fa';
import { Form } from 'react-bootstrap';
import AppNavbar from '../components/AppNavbar';
import BottomNav from '../components/BottomNav';

const PagoClientes: React.FC = () => {
  const navigate = useNavigate();
  const [cedula, setCedula] = useState('');
  const [error, setError] = useState('');

  const handleConsultar = () => {
    if (!cedula.trim()) {
      setError('Por favor ingrese una cédula válida.');
      return;
    }
    setError('');
    navigate(`/r/${btoa(cedula.trim())}`);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <AppNavbar />

      <div style={{ flex: 1, overflowY: 'auto' as const }}>
        <div style={{ background: 'var(--sn-superficie)', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1px solid var(--sn-borde)', position: 'sticky', top: 0, zIndex: 10 }}>
          <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: 'var(--sn-accion)' }}>
            <FaArrowLeft size={18} />
          </button>
          <div style={{ fontWeight: 700, fontSize: 15 }}>💳 Pago Clientes</div>
        </div>

        <div style={{ padding: 16, maxWidth: 480, margin: '0 auto' }}>
          <p style={{ fontSize: 12, color: 'var(--sn-texto-3)', marginBottom: 16 }}>
            Ingresa la cédula del cliente para consultar su cuenta y registrar el pago.
          </p>

          <Form.Group>
            <Form.Label style={{ fontSize: 12, color: 'var(--sn-texto-3)' }}>Número de cédula</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ej: 1312908286"
              value={cedula}
              onChange={e => { setCedula(e.target.value); setError(''); }}
              onKeyDown={e => { if (e.key === 'Enter') handleConsultar(); }}
              autoFocus
            />
          </Form.Group>
          {error && <div style={{ fontSize: 12, color: 'var(--sn-peligro)', marginTop: 6 }}>{error}</div>}

          <button
            type="button"
            onClick={handleConsultar}
            style={{
              width: '100%', marginTop: 14, padding: '10px 12px', border: 'none', borderRadius: 8,
              background: 'linear-gradient(135deg,var(--sn-accion-hover),var(--sn-accion))', color: 'var(--sn-accion-texto)', fontWeight: 700, fontSize: 13,
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}
          >
            <FaSearch size={13} /> Consultar
          </button>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default PagoClientes;
